/* __next_internal_client_entry_do_not_use__ ToastClose auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Close as CloseIcon } from "@faire/web--source/slate/icons/foundation/Close";
import React from "react";
import styled from "styled-components";
import { IconButton } from "../IconButton";
export var ToastClose = function(param) {
    var closeToast = param.closeToast, variant = param.variant;
    var strictLocalize = useStrictLocalization().strictLocalize;
    return /*#__PURE__*/ _jsx(CloseButton, {
        "aria-label": strictLocalize({
            id: "Ouwask",
            defaultMessage: [
                {
                    type: 0,
                    value: "Close toast"
                }
            ]
        }),
        onClick: closeToast,
        shape: "square",
        size: "small",
        variant: variant,
        children: /*#__PURE__*/ _jsx(CloseIcon, {})
    });
};
var CloseButton = styled(IconButton).withConfig({
    componentId: "sc-651352f4-0"
})([
    "flex-shrink:0;margin-block-start:-12px;margin-inline:4px -12px;"
]);
